import { useEffect, useRef, useState } from 'react';
import { getHeaders } from '../services/agent.service';
import HttpService from '../services/http.service';
import { store } from '../context/store';
import { getAgentData, getBrowserSessionId, getUserId, isSettingEnabled } from '../services/util';
import WSocketService from '../services/websocket.service';
import Logger from '../services/logger.service';
import LocalStorageService from '../services/localstorage.service';

const useBrowserEvent = () => {
    const [unloadEvent, setUnloadEvent] = useState(null);
    const isRefresh = useRef(false)
    const mode = store.getState().toolbar.agent.mode;
    const headers = getHeaders();
    let url = HttpService.getURL('agentUrl')
    const blendedModeActiveDialer = store.getState().toolbar.blendedModeActiveDialer;
    const previewDataAfterRefresh = store.getState().toolbar.previewCampaignNumberDetails;
    const campaignSelectedState = previewDataAfterRefresh?.campaignSelectedState || false;
    const callDetails = store.getState().call.callDetails;
    const getPreviewStatus = () => {
        if ((mode === "blended" && blendedModeActiveDialer === "Preview" && campaignSelectedState) || (mode === "preview" && campaignSelectedState)) {
            return true;
        } else {
            return false;
        }
    }
    const reqData = {
        customer: getAgentData()?.customer,
        agentId: getAgentData()?.agentInfo?.agentId,
        userId: getUserId(),
        mode: mode.toUpperCase(),
        agentUniqId: getAgentData().agentUniqId,
        isPreviewNumberAssigned: getPreviewStatus(),
        skillName: callDetails?.skillName || '',
        sessionId: getBrowserSessionId()

    }
    useEffect(() => {
        const handleBeforeUnloadForEvents = (event) => {
            LocalStorageService.setItem('reconnect', true);
            sessionStorage.setItem('sessionReconnect', true);
            let HIDE_REFRESH_POPUP = isSettingEnabled("HIDE_REFRESH_POPUP"); // hide refresh popup 
            if (performance.getEntriesByType('navigation')[0].type === 'reload') {
                setUnloadEvent('refresh');
            } else {
                setUnloadEvent('close');
            }
            const isForced = WSocketService.getAgentForceLogoutByAdmin();
            Logger.log('isForcedLogOutByAdmin', isForced);
            if (!isForced && !HIDE_REFRESH_POPUP) { // no need to show confirmation dialog if forced logout by admin or logout on close is enabled
                event.preventDefault();
                event.returnValue = 'Are you sure you want ?'; // Required for Chrome to show the confirmation dialog
            }
        };

        const handleUnloadForEvents = async () => {

            try {
                let reqBody = {
                    ns: "ozonetel.cloudagent",
                    type: "tbAgentRefresh",
                    ...reqData
                };

                if (unloadEvent === 'refresh' || isRefresh.current) {
                    const options = {
                        method: 'POST',
                        headers: { ...headers, ...{ 'Accept': 'application/json, text/plain, */*', "Content-Type": 'application/json' } },
                        body: JSON.stringify(reqBody),
                        keepalive: true
                    };



                    await fetch(url, options)
                        .then(response => {
                            const time = Date.now();
                            while ((Date.now() - time) < 500) { }
                        })
                        .catch(error => {
                        })
                    const time = Date.now();
                    while ((Date.now() - time) < 500) { }



                } else if (unloadEvent === 'close') {
                    let reqBody = {
                        ns: "ozonetel.cloudagent",
                        type: "tbCloseTab",
                        ...reqData
                    };

                    const options = {
                        method: 'POST',
                        headers: { ...headers, ...{ 'Accept': 'application/json, text/plain, */*', 'Content-Type': 'application/json' } },
                        body: JSON.stringify(reqBody),
                        keepalive: true
                    };

                    await fetch(url, options)
                        .then(response => {
                            const time = Date.now();
                            while ((Date.now() - time) < 500) { }
                        })
                        .catch(error => {
                        })
                    const time = Date.now();
                    while ((Date.now() - time) < 500) {

                    }
                }
                sessionStorage.removeItem('unloadEvent');
            } catch (e) {
                Logger.log(e);
            }
        };

        window.addEventListener('keydown', (event) => {
            if (event.key === 'F5' || (event.ctrlKey && event.key === 'r') || (event.metaKey && event.key === 'r')) {
                isRefresh.current = true
            } else {
                isRefresh.current = false
            }
        });

        window.addEventListener('beforeunload', handleBeforeUnloadForEvents);
        window.addEventListener('unload', handleUnloadForEvents);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnloadForEvents);
            window.removeEventListener('unload', handleUnloadForEvents);
        };
    }, [unloadEvent]);

    return unloadEvent;
};

export default useBrowserEvent;
